<template>
    <div class="col-md-12 my-5">
        <div v-if="gradient" class="row mx-auto">
            <div class="col-md-3 py-0">
                <v-autocomplete
                        outlined
                        dense
                        v-model="gradientColor.dir"
                        label="جهت رنگ"
                        :items="direction"
                        item-value="value"
                        item-text="text"
                >

                </v-autocomplete>
            </div>
            <div class="col-md-4 py-0">
                <v-color-picker
                        v-model="gradientColor.color1"
                        label=" رنگ اول"
                        dot-size="18"
                        required
                        dense
                        class="mt-1"
                        mode="hexa"
                        swatches-max-height="135"
                ></v-color-picker>
            </div>
            <div class="col-md-4 py-0">
                <v-color-picker
                        v-model="gradientColor.color2"
                        label=" رنگ دوم"
                        dot-size="18"
                        required
                        dense
                        class="mt-1"
                        mode="hexa"
                        swatches-max-height="135"
                ></v-color-picker>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "qrColors",
    data() {
        return {
            gradientColor: {
                dir: 'to top',
                color1: '',
                color2: ''
            },
            body: {
                dir: 'to top',
                color1: '',
                color2: ''
            },
            direction: [
                {text: 'از بالا', value: 'to top'},
                {text: 'از پایین', value: 'to bottom'},
                {text: 'از چپ به راست', value: 'to right'},
                {text: 'از راست به چپ', value: 'to left'},
                {text: 'از بالا به چپ', value: 'to top left'},
                {text: 'از بالا به راست', value: 'to top right'},
                {text: 'از پایین به چپ', value: 'to bottom left'},
                {text: 'از پایین به راست', value: 'to bottom right'},
            ],
            gradient: true,
            simple: true,
            borderChange: false,
            borderColor: '',
            changeTexts: false,
            showText: false,

        }
    },
}
</script>

<style scoped>

</style>